/// <amd-module name="SuiteCommerce.CookieConsent.Container"/>
define("SuiteCommerce.CookieConsent.Container", ["require", "exports", "SuiteCommerce.CookieConsent.Common.Configuration", "SuiteCommerce.CookieConsent.Container.View", "SuiteCommerce.CookieConsent.CookiesHandler.Cookies.Model", "SuiteCommerce.CookieConsent.CookiesHandler"], function (require, exports, Configuration_1, ContainerView_1, Cookies_Model_1, CookiesHandler_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            var _a;
            var layout = container.getComponent('Layout');
            if (layout && Configuration_1.Configuration.areAllRequiredFieldsFulfilled) {
                var cookieModelOptions_1 = ((_a = CookiesHandler_1.CookiesHandler.getDecodedCookies()) === null || _a === void 0 ? void 0 : _a.consentSettings) || {
                    ANALYTICS: false,
                    PERFORMANCE: true,
                    THIRDPARTIES: false
                };
                layout.addChildView('Header', function () {
                    return new ContainerView_1.ContainerView({
                        container: container,
                        model: new Cookies_Model_1.CookiesModel(cookieModelOptions_1)
                    });
                });
            }
        }
    };
});
